import * as constants from './comparable-types'
import instance from '../../../services/instance'

export default {
  [constants.GET_COMPARABLE_FULL_LIST] ({ commit, rootState }, params = null) {
    let url = params ? `/comparable/list?${params}` : '/comparable/list'
    return new Promise((resolve, reject) => {
      instance
        .get(url, {
          headers: {
            Authorization: 'Bearer ' + rootState.idToken,
          },
        })
        .then((res) => {
          let { result } = res.data
          commit(constants.SET_COMPARABLE_FULL_LIST, result)
          resolve(result)
        })
        .catch((err) => {
          reject(new Error(err))
        })
    })
  },
}
